import { Linkedin, Mail, Phone, Youtube } from "lucide-react";
import { Link } from "react-router-dom";
import { lines, sz, txt, useContent } from "@/content/ContentContext";

const ContactBar = () => {
  const c = useContent();
  const cb = c.global.contactBar;
  const socials = c.global.socials;

  return (
    <section className="contactbar" id="contact">
      <Link
        to="/contact"
        className="cb-iconbox"
        aria-label="Go to the contact form"
        data-testid="contactbar-mail-icon"
      >
        <Mail className="cb-mail" strokeWidth={1.4} />
      </Link>
      <h4 className="cb-title" style={sz(cb.title)}>{lines(cb.title)}</h4>
      <p className="cb-text" style={sz(cb.text)}>{lines(cb.text)}</p>
      <Link
        to="/contact"
        className="cb-cta"
        style={sz(cb.ctaLabel)}
        data-testid="get-in-touch"
      >
        {txt(cb.ctaLabel)}
      </Link>
      <span className="cb-divider" />
      <div className="cb-info">
        <a href={`tel:${cb.phone.replace(/[^+\d]/g, "")}`} className="cb-info-row cb-info-link" data-testid="contact-phone">
          <Phone className="cb-info-icon" strokeWidth={1.5} />
          {cb.phone}
        </a>
        <a
          href={`mailto:${cb.email}`}
          className="cb-info-row cb-info-link"
          data-testid="contact-email"
        >
          <Mail className="cb-info-icon" strokeWidth={1.5} />
          {cb.email}
        </a>
      </div>
      {(socials.linkedin || socials.youtube) && (
        <div className="cb-socials">
          {socials.linkedin && (
            <a
              href={socials.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="cb-social"
              aria-label="LinkedIn"
              data-testid="social-linkedin"
            >
              <Linkedin strokeWidth={1.6} />
            </a>
          )}
          {socials.youtube && (
            <a
              href={socials.youtube}
              target="_blank"
              rel="noopener noreferrer"
              className="cb-social"
              aria-label="YouTube"
              data-testid="social-youtube"
            >
              <Youtube strokeWidth={1.6} />
            </a>
          )}
        </div>
      )}
    </section>
  );
};

export default ContactBar;
